import { redirect } from 'react-router-dom';

import { buildNoAccessPath } from '../constants';
import { isUnauthorizedError } from 'src/utils/helpers/isUnauthorizedError';

export const baseLoader = async (call, errorMsg, request) => {
	try {
		return await call();
	} catch (error) {
		if (isUnauthorizedError(error)) {
			throw redirect(buildNoAccessPath(request));
		}

		console.error(errorMsg, error);
		throw error;
	}
};
